import React, { useEffect, useState } from "react";
import { Container, Row, Col} from "reactstrap";
import '../../styles/services-list.css'
import { getAddressDetailsInfo } from "../../commonFunction";
import axios from 'axios';

const listAddressLinks = [{}];

const ServicesList=()=> {

    const [listAddressDetails, setAddressDetails] = useState(listAddressLinks);

    useEffect(() => {
        // (async () => {
        fetchTodos();
        // })
      }, []);
      const fetchTodos = async () => {
        try {
         
            //fetching address details
          const addressDetails = await getAddressDetailsInfo("address");
    
          setAddressDetails(addressDetails);
        } catch (err) {
          console.log(err, "error addressDetails");
        }
      };
    
  return (
      <>
           <Container>
               <Row>
                    <Col lg='4' md='4' sm='6' className='mb-1'>
                        <div className="service__item text-center">
                        <span className='mb-3 d-inline-block'>
                        <i className="ri-phone-fill"></i>
                        </span>
                        <h6 className="text-uppercase">Telephone</h6>
                        <p className="section__description">
                        {listAddressDetails.mobileNumber}
                        </p>
                        </div> 
                    </Col>
                    <Col lg='4' md='4' sm='6' className='mb-1'>
                    <div className="service__item text-center">
                        <span className='mb-3 d-inline-block'>
                            < i className="ri-mail-line"></i>
                        </span>
                        <h6 className="text-uppercase">E-mail</h6>
                        <p className="section__description">
                       <p> {listAddressDetails.email1}</p>
                       {/* <p> {listAddressDetails.email}</p> */}
                        </p>
                        </div> 
                    </Col>
                    <Col lg='4' md='4' sm='6' className='mb-1'>
                    <div className="service__item text-center">
                        <span className='mb-3 d-inline-block'>
                          <i className="ri-map-pin-2-line"></i>
                        
                        </span>
                        <h6 className="text-uppercase">address</h6>
                        <p className="section__description">
                        {listAddressDetails.address},<br />{listAddressDetails.zipCode},{listAddressDetails.state},<br />
                        {listAddressDetails.country}.  
                        </p>
                        {/* <p className="section__description">
                        {listAddressDetails.zipCode},{listAddressDetails.state},
                        {listAddressDetails.country}.  
                        </p> */}
                      
                        </div> 
                    </Col>
             </Row>
        </Container>
      </>

  )
}

export default ServicesList;
